export default "__VITE_ASSET__Dyf1DYz2__"